$(document).ready(function() {
  $('#toggle_card').on('click', function(){
    let dashboard_card = document.querySelector('#dashboard_card');
    if (dashboard_card.classList.contains("hidden")) {
      dashboard_card.classList.remove("hidden");
    } else {
      dashboard_card.classList.add("hidden");
    }
  });
});